export const Url = (photoId: number) => `${process.env.REACT_APP_SERVER_URL}/api/v1/file/open-source/download/${photoId}`;